import React from "react";
import styled, { keyframes } from "styled-components";
import { brand_orange_deep } from "../constants/styles";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const SIZES = { sm: 16, md: 32 };

const Ring = styled.span`
  display: inline-block;
  width: ${({ $size }) => SIZES[$size] || SIZES.md}px;
  height: ${({ $size }) => SIZES[$size] || SIZES.md}px;
  border: ${({ $size }) => ($size === "sm" ? 2 : 3)}px solid rgba(216, 89, 7, 0.18);
  border-top-color: ${brand_orange_deep};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

export function Spinner({ size = "md" }) {
  return <Ring $size={size} role="status" aria-label="Loading" />;
}

const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
`;

export function SectionLoader() {
  return (
    <LoaderWrap aria-busy="true" aria-live="polite">
      <Spinner size="md" />
    </LoaderWrap>
  );
}
